module.exports = __webpack_public_path__ + "af896c2763b3bcea6c606aff0edd7d02.svg";